import React from 'react';

import { Alert, AlertTitle, Box, Link } from '@mui/material';

import { getPricingToolTabLabel } from '../constants';
import type { PricingToolTab } from '../types';

import { summarizeMissingRequiredItems } from './findMissingRequiredItems';
import { useRequiredItemsInput } from './useRequiredItemsInput';

interface Props {
  onTabChange: (tab: PricingToolTab) => void;
}

export default function SubmitReadinessAlert({ onTabChange }: Props) {
  const lines = summarizeMissingRequiredItems(useRequiredItemsInput());

  if (lines.length === 0) {
    return null;
  }

  return (
    <Alert severity="warning">
      <AlertTitle>Before you can submit to Salesforce</AlertTitle>
      <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
        {lines.map(({ tab, summary }) => (
          <li key={tab}>
            {summary} (
            <Link component="button" type="button" variant="body2" onClick={() => onTabChange(tab)}>
              {getPricingToolTabLabel(tab)}
            </Link>
            )
          </li>
        ))}
      </Box>
    </Alert>
  );
}
